// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-main[data-v-896126c6]{display:flex;flex-direction:column;flex-grow:1;padding:20px 20px 0;height:100%;overflow-x:hidden}.desktop[data-v-896126c6]{-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text;height:100%}@media screen and (min-width:1199px){.el-main[data-v-896126c6]{padding:0}}.manualScroll[data-v-896126c6]{overflow:hidden!important}.app-wrapper[data-v-896126c6]{height:100%}", ""]);
// Exports
module.exports = exports;
